module.exports = __webpack_public_path__ + "static/media/BunburyHerald-devicecomp-min.fba4deb2.png";